import script from "./Chapter13.vue?vue&type=script&setup=true&lang=js"
export * from "./Chapter13.vue?vue&type=script&setup=true&lang=js"

import "./Chapter13.vue?vue&type=style&index=0&id=37e31927&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37e31927"]])

export default __exports__